<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ search }}<br /><br />
      {{ item }} -->
        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable text-left">
                <b-card-body class="py-0">
                    <b-tabs class="gridtabs">
                        <b-tab :active="true">
                            <template #title>
                                <div class="badgecontainer pr-5">
                                    <i :class="options.icon" class="text-primary mr-1"></i>
                                    {{ item.email }}
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                        }}&gt;</span>
                                </div>
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Email" label-for="email" label-cols="12" label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="email" type="email" size="sm" v-model="item.email"
                                                    placeholder="Enter email"
                                                    :debounce="options.debounce"></b-form-input>
                                                <b-form-invalid-feedback>Email: Required</b-form-invalid-feedback>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" disabled
                                                        @click="item.email = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Mobile for 2FA/OTP" label-for="mobile" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-2fa label=" Cell Phone" v-model="item.mobile" size="sm"
                                                    :darkmode="$store.state.darkMode" placeholder="Cell Phone"
                                                    :debounce="options.debounce" @keyup.native="isChanged()"
                                                    class="w-100pct" />
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Role" label-for="role" label-cols="12" label-size="sm">
                                            <treeselect instanceId="role" type="number" v-model="item.rolename"
                                                :clearable="false" :options="options_roles" :multiple="false">
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Enabled" label-for="status" label-cols="12">
                                            <b-form-radio-group id="status" v-model="item.status" :options="[
                                                { text: 'Yes', value: 0 },
                                                { text: 'No', value: 9 },
                                            ]" buttons button-variant="outline-success" size="sm"
                                                name="radio-btn-outline"></b-form-radio-group>
                                        </b-form-group>
                                    </b-col>

                                    <!--    <b-col cols="12" sm="6">
            <b-form-group
              label="Status"
              label-for="status"
              label-cols="12"
              label-size="sm"
            >
              <b-form-radio-group
                v-model="item.status"
                :options="[
                  { text: 'ENABLED', value: '0' },
                  { text: 'INVITED', value: '1' },
                  { text: 'SIGNUP', value: '2' },
                  { text: 'FORGOT', value: '3' },
                  { text: 'DISABLED', value: '9' },
                ]"
                buttons
                button-variant="outline-success"
                size="sm"
                name="radio-btn-outline"
                :debounce="options.debounce"
              ></b-form-radio-group>
            </b-form-group>
          </b-col> -->
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Firstname" label-for="firstname" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="firstname" type="text" size="sm"
                                                    v-model="item.firstname" :debounce="options.debounce"
                                                    placeholder="Enter firstname"
                                                    @keyup.native="isChanged()"></b-form-input>

                                                <b-form-invalid-feedback>Firstname: Required</b-form-invalid-feedback>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.firstname" @click="item.firstname = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Lastname" label-for="lastname" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="lastname" type="text" size="sm"
                                                    v-model="item.lastname" placeholder="Enter lastname"
                                                    :debounce="options.debounce"
                                                    @keyup.native="isChanged()"></b-form-input>

                                                <b-form-invalid-feedback>Lastname: Required</b-form-invalid-feedback>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.lastname" @click="item.lastname = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Title" label-for="title" label-cols="12" label-size="sm">
                                            <treeselect v-model="item.title" :clearable="true" :options="options_title"
                                                :disabled="false">
                                            </treeselect>
                                            <b-form-invalid-feedback>Title: Required</b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Comments" label-for="comments" label-cols="12">
                                            <b-form-textarea id="comments" v-model="item.comments"
                                                placeholder="Comments" rows="3" max-rows="8"
                                                class="smalltextarea"></b-form-textarea>
                                        </b-form-group> </b-col></b-row>

                                        <b-row align-v="end" class="nopadding my-1 mt-3 background-transparent" no-gutters>
                                    <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                        Company Attributes
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Company" label-for="companyname" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="company" type="text" size="sm" v-model="item.company"
                                                    placeholder="Enter company name"
                                                    @keyup.native="isChanged()"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.company" @click="item.company = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Phone" label-for="telephone" label-cols="12"
                                            label-size="sm">
                                            <b-2fa label="Phone" size="sm" v-model="item.companytelephone"
                                                :darkmode="$store.state.darkMode" placeholder="Telephone"
                                                @keyup.native="isChanged()" />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Extension" label-for="extension" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="extension" type="text" size="sm"
                                                    v-model="item.extension" placeholder="Enter extension"
                                                    @keyup.native="isChanged()"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.extension" @click="item.extension = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Department" label-for="department" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="department" type="text" size="sm"
                                                    v-model="item.department" placeholder="Enter department"
                                                    @keyup.native="isChanged()"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.department" @click="item.department = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Job Title" label-for="jobtitle" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="jobtitle" type="text" size="sm"
                                                    v-model="item.jobtitle" placeholder="Enter jobtitle"
                                                    @keyup.native="isChanged()"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.jobtitle" @click="item.jobtitle = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                            <treeselect placeholder="Select slac..."
                                                searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                                :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                :show-count="true" :flatten-search-results="true"
                                                :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                :disabled="readonly" multiple="true">
                                                <div slot="value-label" slot-scope="{ node }">
                                                    {{ node.raw.id }}
                                                </div>
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Your Ref P/O" label-for="yourref" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="yourref" type="text" size="sm"
                                                    v-model="item.yourref" placeholder="Enter yourref"
                                                    @keyup.native="isChanged()"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.yourref" @click="item.yourref = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Agent, GDS ID" label-for="initials" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="initials" type="text" size="sm"
                                                    v-model="item.initials" placeholder="Enter Initials"
                                                    @keyup.native="isChanged()"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.initials" @click="item.initials = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row align-v="end" class="nopadding my-1 mt-3 background-transparent" no-gutters>
                                    <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                        WFH Attributes
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3" class="text-right">
                                        <b-form-group label="IP Roaming" label-for="iproaming" label-cols="12">
                                            <b-form-radio-group id="iproaming" v-model="item.iproaming" :options="[
                                                { text: 'No', value: '0' },
                                                { text: 'Yes', value: '1' }
                                            ]" buttons button-variant="outline-success" size="sm"
                                                name="radio-btn-outline"></b-form-radio-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="IP Address" label-for="ipaddress" label-cols="12"
                                            label-size="sm">
                                            <b-input-group>
                                                <b-form-input id="ipaddress" type="text" size="sm"
                                                    v-model="item.ipaddress" placeholder="Enter IP address"
                                                    @keyup.native="isChanged()"
                                                    :disabled="item.iproaming == '0' ? true : false"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        :disabled="!item.ipaddress" @click="item.ipaddress = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="6" xl="6">
                                        <b-form-group label="IP Ports" label-for="ipports" label-cols="12"
                                            label-size="sm">
                                            <treeselect v-model="item.ipports" :clearable="true"
                                                :options="options_ipports" :multiple="true"
                                                :disabled="item.iproaming == '0' ? true : false">
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>

                                </b-row>
                            </p>
                        </b-tab>

                        <b-tab>
                            <template #title>
                                <i class="fa fa-unlock text-primary mr-1"></i>Permissions
                            </template>
                            <p class="py-3 px-0">
                                <!-- <b-row>
                <b-col cols="12" sm="12" md="12" xl="12">
                  <b-form-group
                    label="UI Experience (Most suitable)"
                    label-for="experience"
                    label-cols="12"
                    label-size="sm"
                  >
                    <treeselect
                      v-model="experience"
                      :options="options_experience"
                    ></treeselect>
                  </b-form-group>
                </b-col>
              </b-row> -->
                                <b-row>
                                    <b-col cols="12" sm="12" md="12" xl="12">
                                        <b-form-group label="Permissions" label-for="permissions" label-cols="12"
                                            label-size="sm">
                                            <treeselect v-model="item.permissions" :multiple="true" :maxHeight="600"
                                                :show-count="true" :value-consists-of="'LEAF_PRIORITY'"
                                                autoSelectDescendants autoDeselectDescendants
                                                :options="options_permissions"></treeselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab>
                        <b-tab v-if="idselected">
                            <template #title>
                                <i class="fa fa-history text-primary mr-1"></i> Audit
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab>
                    </b-tabs>
                </b-card-body>
                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <!-- v-if="user.permissions.includes('users.save')"-->
                        <b-col cols="auto" class="text-left mr-3">
                            <b-button squared size="sm" variant="primary" @click="saveit"
                                v-if="user.permissions.includes('setup_users.admin')">
                                <i class="fa fa-check"></i>
                                Save It
                            </b-button>
                        </b-col>
                        <b-col class="text-left my-auto">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                                <i class="fa fa-chevron-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
    name: "Setup_Users",

    data() {
        return {
            busy: false,

            readonly: false,
            item: {
                role: {
                    name: "user",
                },
                id: "",
                status: 0,
                email: null,
                company: "Travel Places",
                department: "EVENTS",
                yourref:"",
                slac: [],
                iproaming: "0",
                ipports: []
            },
            options_roles: [],
            experience: null,
            options_experience: [
                { id: "permissions_accounts", label: "Accounts Experience" },
                { id: "permissions_all", label: "All Experience" },
                { id: "permissions_api", label: "API Experience" },
                { id: "permissions_basic", label: "Basic Experience" },
                { id: "permissions_clients", label: "Clients Experience" },
                { id: "permissions_development", label: "Development Experience" },
                { id: "permissions_events", label: "Events Experience" },
                { id: "permissions_f1", label: "F1 Experience" },
                { id: "permissions_prosports", label: "Pro Sports Experience" },
                { id: "permissions_neptune", label: "Neptune Experience" },
            ],
            options_permissions: [],
            options_title: [
                { id: "Mr", label: "Mr" },
                { id: "Mrs", label: "Mrs" },
                { id: "Ms", label: "Ms" },
                { id: "Miss", label: "Miss" },
                { id: "Dr", label: "Dr" },
            ],
            options_ipports: [
                { id: "1433", label: "1433 | SQL Server" },
                { id: "5432", label: "5432 | Postgres" },
                { id: "5000", label: "5000 | RDP Alternate" }
            ],

            options: {
                title: "Users",
                icon: "fa fa-user-circle",
            },
        };
    },
    methods: {

        async loadDDL() {

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_usersroles {
                setup_usersroles {
                id: name
                label: name
              }
            }
          `,
                });
                this.options_roles = response.data.setup_usersroles;
            } catch (error) {
                console.log(error);
            }

            let data = await this.$helpers.getsystemsetting("permissions_ux");
            if (data) {
                this.options_permissions = JSON.parse(data);
            }

        },

        async load() {
            let variables = {
                id: this.idselected,
                dateformat: "YYYY-MM-DD",
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
              query setup_users($id: String) {
                setup_users(id: $id) {
                    id
                    email
                    mobile
                    rolename
                    status
                    firstname
                    lastname
                    title
                    comments
                    company
                    companytelephone
                    extension
                    department
                    yourref
                    jobtitle
                    slac
                    initials
                    permissions     
                    ipaddress
                    ipports
                    iproaming       
                    created_at
                    created_by
                    updated_at
                    updated_by
                }
              }
            `,
                    variables,
                });

                if (response.data.setup_users.length > 0) {
                    this.item = response.data.setup_users[0];

                    this.item.slac = this.item.slac ? this.item.slac.split(",") : [];
                    this.item.ipports = this.item.ipports ? this.item.ipports.split(",") : [];

                    if (this.item.permissions) {

                        this.item.permissions = JSON.parse(this.item.permissions);
                    }

                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },

        async saveit() {
            this.busy = true;

            let variables = { rows: [this.cleanit(this.item)] };

            variables.rows[0].slac =
                variables.rows[0].slac.length > 0
                    ? variables.rows[0].slac.join(",")
                    : null;
            variables.rows[0].ipports =
                variables.rows[0].ipports.length > 0
                    ? variables.rows[0].ipports.join(",")
                    : null;
            variables.rows[0].permissions = JSON.stringify(
                variables.rows[0].permissions
            );

            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_users_save(
                            $rows: [setup_users_input]
                        ) {
                            setup_users_save(rows: $rows) {
                                id
                                email
                                mobile
                                rolename
                                status
                                firstname
                                lastname
                                title
                                comments
                                company
                                companytelephone
                                extension
                                department
                                yourref
                                jobtitle
                                slac
                                initials
                                permissions
                                ipaddress
                                iproaming  
                                ipports   
                            }
                        }
                    `,
                    variables,
                });
                console.log(response);
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
    },
};
</script>

<style></style>